import { Button, Stack, Typography } from '@karma/components';
import { useTranslation } from 'react-i18next';
import { ConeIconFilled } from '@karma/components/icons';
import Alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';
import { PATHS } from 'consts/paths';
import { Body } from './ModalBodyGiftCardNoEmail.style';

const ModalBodyGiftCardNoEmail = () => {
  const { t } = useTranslation();
  const contextDataAttrs = Alooma.useContextDataAttrs();

  return (
    <Body>
      <ConeIconFilled width={60} height={60} />
      <Stack spacing={8} direction="column">
        <Typography variant="h3">{t('app:didNotGetEmail')}</Typography>
        <Typography variant="paragraphLarge">{t('app:checkYourSpam')}</Typography>
      </Stack>
      <Button
        size="medium"
        {...contextDataAttrs}
        data-alooma-element={ALOOMA.ELEMENTS.CONTACT_SUPPORT}
        fullWidth
        as="a"
        href={PATHS.FAQ}
        target="_blank"
      >
        {t('app:contactSupport')}
      </Button>
    </Body>
  );
};

export default ModalBodyGiftCardNoEmail;
